/**
 * en-GB messages added by shared reception task S-SR3 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const sSr3EnGB = {
    // Data protection (the company's copy of its people in the building roll call, and the standing on-site list for marshal phones).
    'dp.hit.sr_roll_call': 'Building roll call entry, {company}',
    'dp.section.sr_roll_call': 'Building roll call (shared reception)',
    'dp.section.sr_on_site': 'On-site list for building fire marshals (shared reception)',
    'dp.retention.sr_roll_call': 'Names on the shared building roll call are deleted this many days after the building evacuation ends.',
};
//# sourceMappingURL=s-sr3.js.map